export default [
  {
    name: 'guide/complete/documents',
    path: '/guide/complete/documents',
    meta: {
      layout: 'EmptyLayout',
      design: { classes: ['px-0'] },
    },
    component: () => import('@/pages/common/guide/DocumentsComplete.vue'),
  },
  {
    name: 'guide/ready/service',
    path: '/guide/ready/service',
    meta: {
      layout: 'EmptyLayout',
    },
    component: () => import('@/pages/common/guide/ReadyForService.vue'),
  },
  {
    name: 'guide/ready/contract',
    path: '/guide/ready/contract',
    meta: {
      layout: 'EmptyLayout',
    },
    component: () => import('@/pages/common/guide/ReadyForContract.vue'),
  },
]
